import { css } from '@emotion/react'
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography
} from '@mui/material'
import { Trans, useTranslation } from 'next-i18next'
import {
  CloseAbsoluteDiv,
  CloseIconContainer,
  ModalBody
} from 'components/Auth/AuthModal.style'
import { CheckIcon } from 'components/Modals/style'
import { Button, ButtonVariant } from 'components/common/Button'
import { LogoButton } from 'components/common/Button/LogoButton'
import { NewFlexContainer } from 'components/common/common.style'
import { WaitingListAttendee } from 'domain/models/WaitingLists/WaitingListsRace'
import { unifiedColors } from 'styles/colors'
import { media } from 'styles/responsive'

interface RegistrationSuccessProps {
  raceName: string
  waitingListAttendee: WaitingListAttendee
  onClose: () => void
}

export const RegistrationSuccess = ({
  raceName,
  waitingListAttendee,
  onClose
}: RegistrationSuccessProps) => {
  const { t } = useTranslation('checkout')
  return (
    <>
      <DialogTitle variant="h4">{t('race.waitingList.title')}</DialogTitle>
      <CloseAbsoluteDiv>
        <LogoButton onClick={onClose} icon={<CloseIconContainer />} noBorder />
      </CloseAbsoluteDiv>
      <DialogContent dividers sx={{ p: 1 }}>
        <ModalBody style={{ gap: 16 }}>
          <Stack
            width="100%"
            flexDirection="row"
            justifyContent="center"
            gap={2}
          >
            <Typography variant="h3">
              <Trans
                i18nKey="race.waitingList.success.title"
                ns="checkout"
                values={{ firstName: waitingListAttendee.firstName }}
                components={{ strong: <strong /> }}
              />
            </Typography>
          </Stack>
          <CheckIcon
            style={{
              color: `${unifiedColors.icon.green}`,
              width: '37px'
            }}
          />
          <Stack textAlign="center">
            <Typography variant="body2">
              <Trans
                i18nKey="race.waitingList.success.message"
                ns="checkout"
                values={{ email: waitingListAttendee.email, race: raceName }}
                components={{ strong: <strong /> }}
              />
            </Typography>
          </Stack>
        </ModalBody>
      </DialogContent>
      <DialogActions
        sx={{ p: 2, padding: '16px 20px' }}
        css={css`
          ${media.maxWidth.sm} {
            padding: 16px 8px;
          }
        `}
      >
        <NewFlexContainer flexDirection="column" width="100%" padding="0 8px">
          <Button
            label={t('race.waitingList.button.close')}
            type="button"
            variant={ButtonVariant.Primary}
            fullWidth
            onClick={onClose}
          />
        </NewFlexContainer>
      </DialogActions>
    </>
  )
}
